import { render, staticRenderFns } from "./old-dashboard.vue?vue&type=template&id=0eabc35d"
import script from "./old-dashboard.vue?vue&type=script&lang=js"
export * from "./old-dashboard.vue?vue&type=script&lang=js"
import style0 from "./old-dashboard.vue?vue&type=style&index=0&id=0eabc35d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports